import React, { useState } from "react";
import { Button } from "../ui/button";
import { loadImage } from "../../../common/services/uiService";

const ImportPermissionsModal = ({
  show,
  onHide,
  onImport,
  groups = [],
  currentGroupId,
  isImporting = false,
}) => {
  const [selectedGroupName, setSelectedGroupName] = useState("");

  // Load the loading icon
  const loadingIcon = loadImage("loading_continuous.gif");

  // Filter out the current group from the options
  const availableGroups = groups.filter((group) => group.id !== currentGroupId);

  const handleImport = () => {
    if (selectedGroupName && onImport) {
      onImport(selectedGroupName);
    }
  };

  const handleHide = () => {
    setSelectedGroupName("");
    onHide();
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg max-w-md w-full mx-4">
        {/* Body */}
        <div className="px-6 pt-4">
          <p className="text-sm text-gray-800 mb-1 pb-4">
            Select a group to import permissions from:
          </p>

          <div className="mb-4">
            <select
              id="source-group"
              value={selectedGroupName}
              onChange={(e) => setSelectedGroupName(e.target.value)}
              className="w-full px-3 border border-gray-800 rounded-md shadow-sm focus:!outline-none text-gray-900 bg-gray-100"
              disabled={isImporting}
            >
              <option value="" disabled style={{ color: "#9CA3AF" }}>
                Select a group...
              </option>
              {availableGroups.map((group) => (
                <option
                  key={group.id}
                  value={group.name}
                  style={{ color: "#111827" }}
                >
                  {group.name}
                </option>
              ))}
            </select>
          </div>

          {availableGroups.length === 0 && (
            <p className="text-sm text-gray-500 mb-4">
              No other groups available to import from.
            </p>
          )}
        </div>

        {/* Footer */}
        <div className="px-6 pb-4 flex justify-end gap-3">
          <Button variant="outline" onClick={handleHide} disabled={isImporting}>
            Cancel
          </Button>
          <Button
            onClick={handleImport}
            disabled={
              !selectedGroupName || isImporting || availableGroups.length === 0
            }
          >
            {isImporting ? (
              <img
                src={loadingIcon}
                alt="loading"
                className="h-auto w-5 object-cover"
              />
            ) : (
              "Import"
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ImportPermissionsModal;
